import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button/Button';
import InputText from '../../components/Input/InputText';
import { session } from '../../helpers/helpers';
import { apiInstance } from '../../utils/api';

const ConfirmPassword = () => {
  const token = session.get('token');
  const [email, setEmail] = useState('');
  const [isSuccess, setIsSuccess] = useState();
  const [errorsInPost, setErrorsInPost] = useState([]);
  const [recoveryLoading, setRecoveryLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  useHistory(); // сохраняем вызов если побочный эффект не нужен, иначе можно удалить полностью

  const ROUTES = {
    PASSWORD: new URL(`${process.env.REACT_APP_API_URL}/auth/forgot-password`),
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onChange = (e) => {
    setEmail(e.target.value);
    setErrorsInPost([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Валидация email
    if (!validateEmail(email)) {
      setErrorsInPost(['Введіть правильний email']);
      return;
    }
    setRecoveryLoading(true);
    apiInstance(ROUTES.PASSWORD, 'POST', { email: email })
      .then((response) => {
        setErrorsInPost([]);
        setIsSuccess(response.ok);
        setShowMessage(true);
        setTimeout(() => setShowMessage(false), 13000);
      })
      .catch(() => {
        setErrorsInPost('Щось пішло не так');
        setShowMessage(true);
        setTimeout(() => setShowMessage(false), 3000);
      })
      .finally(() => setRecoveryLoading(false));
  };

  return (
    <div className="signin">
      <div className="signin__col signin__col_form">
        <a href="/" className="signin__link">
          <img src="/images/logo.svg" alt="logo" />
        </a>

        <div className="signin__inner">
          <div className="text-black-bold-f40-l48">Забули пароль?</div>
          <div className="text-grey-dark-normal-f16-l28">
            Вкажіть ваш email, і ми надішлемо інструкцію <br />
            для відновлення доступу
          </div>

          <form onSubmit={handleSubmit} className="form recovery-password-form">
            <InputText
              id="recovery-email"
              label="Email:"
              onChange={onChange}
              error={!isEmpty(errorsInPost) && errorsInPost}
            />
            <Button
              type="submit"
              text="Надіслати"
              bg="pink"
              block
              loading={recoveryLoading}
              loaderPosition="replace"
              loaderSize={20}
            />

            {/* Повідомлення, яке зникає через 10 секунд */}
            {showMessage && (
              <div className={isSuccess ? 'text-green-normal-f16-l28' : 'text-red-normal-f16-l28'}>
                {isSuccess ? 'Перевірте свою пошту 🙂' : null}
              </div>
            )}
          </form>
        </div>
      </div>

      <div className="signin__col signin__col_banner" />
    </div>
  );
};

export default ConfirmPassword;
